/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.account.company.controllers', [
  'acme.common.service.api',
  'acme.common.service.auth',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.directive.inputField',
  'acme.common.service.userPreferences'
])

.controller('AccountCompanyController', ['$scope', '$log', '$timeout', 'AuthService', 'ApiService', 'HelpersService', 'NoticeFactory', 'ValidateService', function($scope, $log, $timeout, AuthService, ApiService, HelpersService, NoticeFactory, ValidateService) {

    $scope.accountCompany = {

      model: {
        tenant: {}
      },

      countries: [
        {
          name: 'United States',
          alpha2Code: 'US'
        },
        {
          name: 'Canada',
          alpha2Code: 'CA'
        },
        {
          name: 'New Zealand',
          alpha2Code: 'NZ'
        },
        {
          name: 'Other',
          alpha2Code: 'OTHER'
        }
      ],

      selectedCountry: {},


      currentImage: {},
      noticeTimer: {},

      tz: [
        {
          name: 'New Zealand',
          label: 'New Zealand Standard Time (NZST)'
        },
        {
          name: 'Hawaii',
          label: 'Hawaii Standard time (HST)'
        },
        {
          name: 'Pacific',
          label: 'Pacific Standard Time (PST)'
        },
        {
          name: 'Eastern',
          label: 'Eastern Standard Time (EST)'
        },
        {
          name: 'Central',
          label: 'Central Standard Time (CST)'
        },
        {
          name: 'Mountain',
          label: 'Mountain Time (MST/MDT)'
        },
        {
          name: 'Arizona',
          label: 'Arizona (America/Phoenix)'
        },
        {
            name: 'UK',
            label: 'UK (GMT/BST)'
        },
        {
            name: 'Ireland',
            label: 'Ireland (GMT/IST)'
        },
        {
            name: 'WesternEuropean',
            label: 'Western European Time (WET/WEST)'
        },
        {
            name: 'CentralEuropean',
            label: 'Central European Time (CET/CEST)'
        },
        {
            name: 'EasternEuropean',
            label: 'Eastern European Time (EET/EEST)'
        }
      ],
      
      selectedTZ: {},

      notice: {},
            
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Company Profile',
          buttonRight: {
            label: 'Update',
            permissions: ['COMPANY_PROFILE_UPDATE','GLOBAL_CALENDAR_UPDATE'],
            action: function() {
              $scope.accountCompany.prepare();
            }
          }
        });
        $scope.$on('upload::done', this.onUploadDone);
        $scope.$on('AccountCompanyHours::complete', this.onAccountCompanyHoursComplete);
        $scope.$on('upload::error', this.onUploadError);
        this.getTenant(AuthService.getCookie('user').tenantId);
        this.notice = new NoticeFactory();
      },

      prepare: function() {
        $scope.$broadcast('AccountCompany::complete');
      },

      complete: function() {
        if (ValidateService.validate([
          { len: { value: this.model.tenant.city } },
          { len: { value: this.model.tenant.streetAddress1 } },
          { len: { value: this.model.tenant.name } }
        ])) {
          this.notice.hideSuccessMessages();
          this.notice.hideErrorMessages();
          ApiService.tenant.update(this.model.tenant).then(this.success.complete, this.error.complete);
        }else{
          this.notice.showErrorMessages([
            { message: 'Please correct the errors below.' }
          ]);
        }
      },

      getConsumerLink: function() {
        return this.model.tenant.consumerPage + '/list';
      },

      getTenant: function(id) {
        ApiService.tenant.view().then(this.success.getTenant, this.error.getTenant);
      },

      isValidPhone: function() {
        if (this.notice.isLoaded) {
          return ValidateService.validate([
            { phone: this.model.tenant.phoneNumber }
          ]);
        }
      },

      isValidCity: function() {
        return this.isValidLen(this.model.tenant.city);
      },

      isValidStreet: function() {
        return this.isValidLen(this.model.tenant.streetAddress1);
      },

      isValidCompanyName: function() {
        var r = true;
        if(this.notice.isLoaded) {
          if (!this.isValidLen(this.model.tenant.name)) {
            this.notice.companyName ='A valid company name is required';
            r = false;
          }
        }

        return r;
      },

      isValidName: function(value) {
        var r;

        if (this.notice.isLoaded) {
          r = ValidateService.validate([
            { name: this.model.tenant.name }
          ]);
        }else{
          // Don't test undefined values
          r = true;
        }

        return r;

      },

      isValidLen: function(value) {
        var r;
        if (this.notice.isLoaded) {
          r = ValidateService.validate([
            { len: { value: value } }
          ]);
        }else{
          // Don't test undefined values
          r = true;
        }

        return r;

      },

      removeLogoImage: function() {
        $scope.$broadcast('upload::delete', this.currentImage);
        this.model.tenant.logoImage = null;
        delete this.model.tenant.logoImage;
        this.complete();
      },

      onUploadDone: function(e, data) {
        var self = $scope.accountCompany;
        self.currentImage = data;
        if(data.file) {
          self.model.tenant.logoImage = data.file.thumbnailPath;
        }
        self.complete();
      },

      onUploadError: function(e, data) {
        var self = $scope.accountCompany;
        self.notice.showErrorMessages([{
          message: data.result.error || 'There was an error uploading the file.'
        }]);
      },

      onTimezoneUpdate: function() {
        $scope.accountCompany.model.tenant.timezone = $scope.accountCompany.selectedTZ.name;
      },

      onSelectedCountryUpdate: function() { 
        if ($scope.accountCompany.selectedCountry) {
          $scope.accountCompany.model.tenant.country = $scope.accountCompany.selectedCountry.name;
        } else {
          $scope.accountCompany.model.tenant.country = "";
        }
      },

      getCountries: function() {
        ApiService.form.avs.countries().then(this.success.getCountries, this.error.getCountries);
      },

      findCountry: function(name) {
        var i, ii,
          r = false;

        for (i=0,ii=this.countries.length;i<ii;i++) {
          if (this.countries[i].name === name || this.countries[i].alpha2Code === name || this.countries[i].alpha3Code === name) {
            r = {
              country: this.countries[i],
              index: i
            };
            break;
          }
        }

        return r;
      },

      setDefaultCountry: function(country) {
        this.model.tenant.country = country.name;
        this.selectedCountry = country;
        
      },

      success: {
        complete: function(response) {
          $timeout.cancel($scope.noticeTimer);
          $scope.accountCompany.notice.showSuccessMessages([{
            message: 'Successfully Saved!'
          }]);

          $scope.noticeTimer = $timeout(function() {
            $scope.accountCompany.notice.hideSuccessMessages();
          }, 3000);
        },

        getTenant: function(response) {
          var i, ii,
          self = $scope.accountCompany;

          $scope.accountCompany.notice.isLoaded = true;
          $scope.accountCompany.model.tenant = response.data.tenant;
          for (i=0,ii=$scope.accountCompany.tz.length;i<ii;i++) {
            if ($scope.accountCompany.tz[i].name === $scope.accountCompany.model.tenant.timezone) {
              $scope.accountCompany.selectedTZ = $scope.accountCompany.tz[i];
              break;
            }
          }
          $scope.accountCompany.model.tenant.donateURL = $scope.accountCompany.model.tenant.consumerPage.replace(/events/gi, 'donate');
          self.getCountries();
        },

        getCountries: function(response) {
          var found, 
              self = $scope.accountCompany;

          self.countries = response.data.payload;
          if (!self.model.tenant.country) {
            self.setDefaultCountry(self.countries[0]);
          } else {
            found = self.findCountry(self.model.tenant.country);
            if (found) {
              self.selectedCountry = found.country;
              self.model.tenant.country = found.country.name;
            } 
          } 
        },
      },

      error: {
        complete: function(response) {
          $scope.accountCompany.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        getTenant: function(response) {
          $scope.accountCompany.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        getCountries: function(response) {}
      },

      onAccountCompanyHoursComplete: function(e, data) {

        var self = $scope.accountCompany;

        if (data.valid) {
          self.complete();
        }else{
          self.notice.showErrorMessages([
            { message: 'Please correct the errors below.' }
          ]);
        }

      }

    };

    $scope.accountCompany.init();

}])

.controller('AccountCompanyHoursController', ['$scope', '$log', '$timeout', '$filter', 'AuthService', 'ApiService', 'HelpersService', 'NoticeFactory', 'ValidateService', function($scope, $log, $timeout, $filter, AuthService, ApiService, HelpersService, NoticeFactory, ValidateService) {

    $scope.accountCompanyHours = {

      model: {},
      componentType: 'globalCalendar',
      key: '', // calendar key for audit trail
      openDays: [],
      isSubmitted: false,
      standardHours: [
        {
          day: 'Sunday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        },
        {
          day: 'Monday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        },
        {
          day: 'Tuesday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        },
        {
          day: 'Wednesday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        },
        {
          day: 'Thursday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        },
        {
          day: 'Friday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        },
        {
          day: 'Saturday',
          hours: [{
            startTime: '',
            endTime: '',
            hoursOpen: 0
          }],
          closed: false
        }
      ],

      exceptions: [],

      init: function() {
        console.log('AccountCompanyHours::init');
        this.getHours();
        $scope.$on('AccountCompany::complete', this.onAccountCompanyComplete);
      },

      initStartTimes: function() {
        var i, ii,
            j, jj,
            times = this.getInitTimes();

        for (i=0,ii=this.standardHours.length;i<ii;i++) {
          for (j=0,jj=this.standardHours[i].hours.length;j<jj;j++) {
            this.standardHours[i].hours[j].startTime = times.startTime;
            this.standardHours[i].hours[j].endTime = times.endTime;
            this.updateHoursOpen(this.standardHours[i].hours[j]);
          }
        }

      },

      getInitTimes: function() {
        var endDate = new Date(),
            startDate = new Date(),
            startTime,
            endTime;

        startDate.setHours(9);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        startDate.setMilliseconds(0);
        startTime = startDate;

        endDate.setHours(17);
        endDate.setMinutes(0);
        endDate.setSeconds(0);
        endDate.setMilliseconds(0);
        endTime = endDate;

        return {
          startTime: startTime,
          endTime: endTime
        };
      },

      addTime: function(hour, hourIndex) {

        console.log('addTime', hourIndex);

        var endTime = hour.hours[hourIndex].endTime,
            time = {
              startTime: '',
              endTime: '',
              hoursOpen: 0
            };

        // If the day is closed perform no actions
        if (hour.closed) { return; }

        time.startTime = new Date();
        time.startTime.setHours(endTime.getHours());
        time.startTime.setMinutes(endTime.getMinutes());

        time.endTime = new Date();
        time.endTime.setHours(endTime.getHours() + 1);
        time.endTime.setMinutes(endTime.getMinutes());

        time.hoursOpen = this.updateHoursOpen(time);

        hour.hours.push(time);

        this.update();

      },

      removeTime: function(hour, hourIndex) {

        // If the day is closed perform no actions
        if (hour.closed) { return; }

        hour.hours.splice(hourIndex, 1);

        this.update();

      },

      addException: function() {
        var times = this.getInitTimes();
        this.exceptions.unshift({
          name: '',
          date: new Date(),
          startTime: times.startTime,
          endTime: times.endTime,
          closed: true
        });
        this.update();
      },

      removeException: function(index) {
        this.exceptions.splice(index, 1);
        this.update();
      },

      isValidName: function(name) {
        return ValidateService.validate({
          len: { value: name }
        });
      },

      getHours: function() {
        ApiService.tenant.calendar.detail().then(this.success.getHours, this.error.getHours);
      },

      toggleClosed: function(hour) {
        hour.closed = !hour.closed;
        this.update();
      },

      updateHoursOpen: function(hour) {

        var diff = hour.endTime.getTime() - hour.startTime.getTime();

        hour.hoursOpen = (diff / (1000 * 60 * 60)) % 24;
      },

      updateHourSlot: function(hour) {
        this.updateHoursOpen(hour);
        this.update();
      },

      update: function() {

        this.updateStandardHours();
        this.updateExceptions();

      },

      updateStandardHours: function() {

        var i, ii,
            j, jj,
            time,
            r = [];

        for (i=0,ii=this.standardHours.length;i<ii;i++) {
          if (!this.standardHours[i].closed) {
            time = {
              hours: [],
              weekdays: [
                this.standardHours[i].day
              ]
            };
            for (j=0,jj=this.standardHours[i].hours.length;j<jj;j++) {
              time.hours.push($filter('date')(this.standardHours[i].hours[j].startTime, 'HH:mm') + '-' + $filter('date')(this.standardHours[i].hours[j].endTime, 'HH:mm'));
            }
            r.push(time);
          }
        }

        this.model.standard = r;
        console.log('AccountCompanyHoursController::update', this.model);

      },

      updateExceptions: function() {
        var i, ii,
            time,
            r = [];

        for (i=0,ii=this.exceptions.length;i<ii;i++) {

          time = {
            name: this.exceptions[i].name,
            hours: [ 'closed' ],
            date: $filter('date')(this.exceptions[i].date, 'yyyy-MM-dd')
          };

          if (!this.exceptions[i].closed) {
            time.hours = [ $filter('date')(this.exceptions[i].startTime, 'HH:mm') + '-' + $filter('date')(this.exceptions[i].endTime, 'HH:mm') ];
          }
          r.push(time);
        }

        this.model.exceptions = r;
        console.log('AccountCompanyHoursController::update', this.model);

      },

      extractDate: function(dateString) {

        var split = dateString.split('-'),
            d = new Date(split[0], parseInt(split[1], 10) - 1, split[2]);

        return d;
      },

      extractStartEndTime: function(range) {
        var split = range.split('-'),
            startHour = split[0].split(':')[0],
            startMinute = split[0].split(':')[1],
            endHour = split[1].split(':')[0],
            endMinute = split[1].split(':')[1],
            startTime = new Date(),
            endTime = new Date();

        startTime.setHours(parseInt(startHour, 10));
        startTime.setMinutes(parseInt(startMinute, 10));

        endTime.setHours(parseInt(endHour, 10));
        endTime.setMinutes(parseInt(endMinute, 10));

        return {
          startTime: startTime,
          endTime: endTime
        };
      },

      checkOpenDays: function() {
        var i, ii,
            times;

        for (i=0,ii=this.standardHours.length;i<ii;i++) {
          if (this.openDays.indexOf(this.standardHours[i].day) === -1) {
            times = this.getInitTimes();
            this.standardHours[i].hours[0].startTime = times.startTime;
            this.standardHours[i].hours[0].endTime = times.endTime;
            this.standardHours[i].closed = true;
          }
        }

      },

      validateCompanyHours: function() {

        var i, ii,
            j, jj,
            r = true;

        if (this.standardHours instanceof Array) {
          outer: for (i=0,ii=this.standardHours.length;i<ii;i++) {
            if (this.standardHours[i].hours instanceof Array) {
              for (j=0,jj=this.standardHours[i].hours.length;j<jj;j++) {
                if (this.standardHours[i].hours[j].startTime.getTime() >= this.standardHours[i].hours[j].endTime.getTime()) {
                  r = false;
                  break outer;
                }
              }
            }
          }
        }

        return r;

      },

      validateExceptions: function() {

        var i, ii,
            r = true;

        if (this.exceptions instanceof Array) {
          for (i=0,ii=this.exceptions.length;i<ii;i++) {
            if (this.exceptions[i].startTime.getTime() >= this.exceptions[i].endTime.getTime()) {
              r = false;
              break;
            }
          }
        }

        return r;

      },

      process: function() {
        var i, ii,
            j, jj;

        if (this.model.hasOwnProperty('standard')) {
          for (i=0,ii=this.model.standard.length;i<ii;i++) {
            // Move data from the model to our UI data structure
            for (j=0,jj=this.standardHours.length;j<jj;j++) {
              if (this.standardHours[j].day === this.model.standard[i].weekdays[0]) {
                // save open days for UI
                console.log(this.standardHours[j].day, this.model.standard[i].weekdays[0]);
                this.openDays.push(this.model.standard[i].weekdays[0]);
                this.processHours(i, j);
                break;
              }
            }
          }
        }

        this.checkOpenDays();

      },

      processHours: function(modelIndex, standardHoursIndex) {

        var i, ii;

        // Make our standardHours just as long as hour incoming hours
        this.standardHours[standardHoursIndex].hours = [];

        for (i=0,ii=this.model.standard[modelIndex].hours.length;i<ii;i++) {
          this.standardHours[standardHoursIndex].hours.push(this.extractStartEndTime(this.model.standard[modelIndex].hours[i]));
        }

      },

      processExceptions: function() {

        var i, ii,
            times,
            exception,
            closed;

        if (this.model.hasOwnProperty('exceptions')) {
          for (i=0,ii=this.model.exceptions.length;i<ii;i++) {
            if (this.model.exceptions[i].hours[0] === 'closed') {
              times = this.getInitTimes();
              closed = true;
            }else{
              times = this.extractStartEndTime(this.model.exceptions[i].hours[0]);
              closed = false;
            }
            exception = {
              name: this.model.exceptions[i].name,
              date: this.extractDate(this.model.exceptions[i].date),
              startTime: times.startTime,
              endTime: times.endTime,
              closed: closed
            };

            this.exceptions.push(exception);
          }
        }

      },

      hasValidHours: function(hours) {
        return (hours && hours.startTime && hours.endTime && hours.startTime.getTime() >= hours.endTime.getTime());
      },

      complete: function() {
        this.isSubmitted = true;

        if (AuthService.hasPermission('GLOBAL_CALENDAR_UPDATE') &&
            this.validateCompanyHours() &&
            this.validateExceptions()) {
          this.update();
          ApiService.tenant.calendar.update(this.model).then(this.success.complete, this.error.complete);
        }else{
          this.isSubmitted = false;
          $scope.$emit('AccountCompanyHours::complete', { valid: false });
        }
      },

      success: {
        getHours: function(response) {
          $scope.accountCompanyHours.model = response.data.payload;
          $scope.accountCompanyHours.key = response.data.payload.id;

          if ($scope.accountCompanyHours.model.hasOwnProperty('standard')) {
            $scope.accountCompanyHours.process();
          }else{
            $scope.accountCompanyHours.initStartTimes();
          }

          if ($scope.accountCompanyHours.model.hasOwnProperty('exceptions')) {
            $scope.accountCompanyHours.processExceptions();
          }

        },
        complete: function(response) {
          if (response.data.payload.id) {
            $scope.accountCompanyHours.model.id = response.data.payload.id;
          }
          $scope.$emit('AccountCompanyHours::complete', { valid: true });
          $scope.accountCompanyHours.isSubmitted = false;
        }
      },

      error: {
        getHours: function(response) {},

        complete: function(response) {
          $scope.$emit('AccountCompanyHours::complete', { valid: false });
          $scope.accountCompanyHours.isSubmitted = false;
        }
      },

      onAccountCompanyComplete: function() {
        $scope.accountCompanyHours.complete();
      }

    };

    $scope.accountCompanyHours.init();
}])
.controller('AccountCompanyHoursDatePickerController', ['$scope', 'UserPreferencesService', '$timeout', function($scope, UserPreferencesService, $timeout) {

  $scope.accountCompanyHoursDatePicker = {

    isOpen: false,

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },
    
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    
    isPreferenceLoaded: false,

    init: function() {
      console.log('AccountCompanyHoursDatePicker::init');
      this.today();
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      $scope.format = $scope.formats[1];
      $scope.minDate = this.getMinDate();
      $scope.maxDate = this.getMaxDate();
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
          $scope.accountCompanyHoursDatePicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    getMinDate: function() {

      var d = new Date();

      d.setMonth(0);
      d.setDate(1);

      return d;

    },

    getMaxDate: function() {

      var d = new Date();

      d.setMonth(11);
      d.setDate(31);

      return d;

    },

    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.minDate = this.getMinDate();
      $scope.maxDate = this.getMaxDate();

      this.isOpen = true;
    },
    onDateFormatLoad: function (e, data) {
      var self = $scope.accountCompanyHoursDatePicker;
      self.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };

  $scope.accountCompanyHoursDatePicker.init();

}]);